// removed by extract-text-webpack-plugin
module.exports = {"normal":"normal__1SLxB","disabled":"disabled__3Sfwj normal__1SLxB"};


//////////////////
// WEBPACK FOOTER
// ./components/forms/styles/button.scss
// module id = ErYj
// module chunks = 0